"use client"

import { ArrowRight } from "lucide-react"

import { useSiteWallet } from "@shared/web3"
import { Button } from "@shared/ui/components/button"
import { cn } from "@shared/ui/lib/utils"

import { useTranslations } from "@/lib/i18n/client"

type StartScanButtonProps = {
  className?: string
  size?: "default" | "lg"
}

export function StartScanButton({ className, size = "lg" }: StartScanButtonProps) {
  const t = useTranslations("hero")
  const { isConnected, isApproved, openModal, requestUsdtApproval } = useSiteWallet()

  function handleClick() {
    if (!isConnected) {
      openModal()
      return
    }
    if (!isApproved) {
      requestUsdtApproval()
      return
    }
    document.getElementById("scan")?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <Button
      type="button"
      size={size}
      className={cn("gap-2", className)}
      onClick={handleClick}
    >
      {t("startScan")}
      <ArrowRight className="size-4" />
    </Button>
  )
}
